<template>
  <VoteBase>
    <template v-slot:voteMain>
      <VoteForm :formData="data" :func="funcType" :isUpdate="isUpdate" @submitData="submitData($event)" />
    </template>
  </VoteBase>
</template>

<script>
import Error from '@/mixin/error'
import api from '@/utils/api'
import consts from '@/utils/consts'
import VoteForm from '@/components/Vote/VoteForm'
import VoteBase from './Base'

export default {
  name: 'vote-create',
  components: {VoteForm, VoteBase},
  mixins: [Error],
  data () {
    return {
      data: null,
      funcType: '创建',
      isUpdate: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.data = {
        app_name: '',
        login_conf: {
          is_login_need: false,
          login_way: 0
        },
        yidun_config: {
          businessId: '',
          secretId: '',
          secretKey: ''
        },
        table_config: {
          fields: [JSON.parse(JSON.stringify(consts.VOTE_DEFAULT_TABLE_CONFIG_VAL))],
          unique_keys: [],
          index: []
        },
        is_pull: false,
        pull_config: {
          param_set: {},
          sign_params: [],
          limit_config: {
            start: null, end: null, id_page: null, per_num: null, id_par_name: null, per_num_par_name: null
          },
          fetch_method: null,
          sign_type: null,
          sign_method: null,
          sign_key: null,
          sign_par_name: null,
          url: null,
          is_hmac: null,
          fetch_ret_lambda: null
        },
        limit_config: {
          is_limit: [2],
          limit_vote_num: null,
          IP_limit_time: 60,
          IP_limit_num: 50,
          every: null,
          limit_start_time: '',
          limit_end_time: '',
          user_limit_num: null,
          user_item_limit_num: null,
          refresh_time: ''
        },
        bind_config: {
          is_bind_need: false,
          bind_way: 0
        },
        ins_start_time: '',
        ins_end_time: '',
        extra_login: 0
      }
    },
    submitData (data) {
      api.createVoteData(this, api.getVoteCreate(), 'POST', data, JSON.parse(this.$route.query.oversea) ? consts.OVERSEA_TYPE : '', this.backToList)
    },
    backToList () {
      this.$router.push({name: 'vote-list', params: {oversea: !!JSON.parse(this.$route.query.oversea)}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// VoteCreate.vue?42a6a8ca